module.exports = {
    /**
     * Checks the `openChat` query parameter and opens the chat if it is set to `true`
     */
    autoOpenChat() {
        if (typeof window.sprChat === "function") {
            const url = new URL(window.location.href);

            if (url.searchParams.get("openChat") === "true") {
                window.sprChat("open");
            }
        }
    }
};
